var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './index.scss';
import { Button } from 'ii-react-sdk/form_components';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useSelector } from 'react-redux';
import MetadataForm from '~/components/metadata_form';
import Modal from '~/components/modal';
import { UploadDocumentProvider, useUploadDocument } from './upload_provider';
const ACCEPTED_FILE_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];
const OldUploadDocumentModal = (props) => {
    const { isModalVisible, hideModal } = props;
    const { orgMetadata: anyOrgMetadata } = useSelector((state) => state.orgMetadataState);
    const orgMetadata = anyOrgMetadata;
    const { selectedFile, setSelectedFile, metadata, handleFormChange, submitFile, uploadInProgress, successMessage, errorMessage, resetModel, } = useUploadDocument();
    const [requiredFields, setRequiredFields] = useState([]);
    const [requiredErrors, setRequiredErrors] = useState([]);
    const onDrop = useCallback((acceptedFiles) => {
        setSelectedFile(acceptedFiles[0]);
    }, [setSelectedFile]);
    const { getRootProps, getInputProps, } = useDropzone({ multiple: false, accept: ACCEPTED_FILE_TYPES.join(', '), onDrop });
    useEffect(() => {
        if (!orgMetadata)
            return;
        setRequiredFields(orgMetadata.reduce((required, orgMetadataField) => {
            if (orgMetadataField.isRequired) {
                required.push(orgMetadataField.name);
            }
            return required;
        }, []));
    }, [orgMetadata]);
    const hasRequiredFields = () => {
        for (const requiredField of requiredFields) {
            const fieldIndex = metadata.findIndex(metadataField => metadataField.name === requiredField);
            if (fieldIndex === -1)
                return false;
        }
        return true;
    };
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (requiredErrors.length > 0 || !hasRequiredFields()) {
            return;
        }
        submitFile();
    });
    const onHideModel = () => {
        resetModel();
        hideModal();
    };
    let fileSize = '';
    if (selectedFile) {
        fileSize = `${selectedFile.size} bytes`;
        if (selectedFile.size > 2000) {
            fileSize = `${Math.round(selectedFile.size / 1000)} KB`;
        }
        if (selectedFile.size > 2000000) {
            fileSize = `${Math.round(selectedFile.size / 1000000)} MB`;
        }
    }
    return (React.createElement(Modal, { className: 'old-add-document-modal', visible: isModalVisible, onHide: onHideModel },
        React.createElement("div", { className: 'title' },
            React.createElement("h6", null, "Upload Document")),
        React.createElement("div", { className: 'document-form' },
            React.createElement("div", { className: 'required-legend' }, "Fields marked with * are required fields"),
            React.createElement("div", Object.assign({}, getRootProps({ className: 'dropzone' })),
                React.createElement("input", Object.assign({}, getInputProps())),
                React.createElement("p", null, "Drag document, or click to select files")),
            selectedFile && React.createElement("div", { className: 'file-info' },
                React.createElement("div", { key: selectedFile.name },
                    selectedFile.name,
                    " - ",
                    fileSize,
                    React.createElement(Button, { plain: true, onClick: () => setSelectedFile(null) }, "X"))),
            orgMetadata === null
                ? React.createElement("div", { className: 'loading-metadata' },
                    React.createElement(LoadingElement, { isLightBackground: true }))
                : React.createElement("div", { className: 'document-form-fields' },
                    React.createElement(MetadataForm, { orgMetadata: orgMetadata, twoColumns: true, requiredFields: requiredFields, updateRequiredErrors: setRequiredErrors, handleFormChange: handleFormChange, metadata: metadata })),
            React.createElement("div", { className: 'msg-btn' },
                React.createElement("div", { className: 'form-column' },
                    !!(errorMessage.length) && React.createElement("div", { className: 'error-msg' }, errorMessage),
                    !!(successMessage.length) && React.createElement("div", { className: 'success-msg' }, "Document uploaded!")),
                !successMessage.length && React.createElement(Button, { className: 'upload-submit', onClick: handleSubmit, disabled: !selectedFile || uploadInProgress || requiredErrors.length > 0 || !hasRequiredFields() }, uploadInProgress ? 'Uploading...' : 'Upload Document'),
                !!(successMessage.length) && React.createElement(Button, { className: 'upload-submit', onClick: onHideModel }, "Close")))));
};
const OldUploadDocumentModalWrapper = (props) => {
    return (React.createElement(UploadDocumentProvider, null,
        React.createElement(OldUploadDocumentModal, Object.assign({}, props))));
};
export default OldUploadDocumentModalWrapper;
